(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/filters"],{

/***/ "./src/js/filters.js"
/*!***************************!*\
  !*** ./src/js/filters.js ***!
  \***************************/
() {

document.addEventListener('DOMContentLoaded', function () {
  var filterForm = document.querySelector('#js-filters');
  var sortSelect = document.querySelector('#js-sort-by');
  if (!sortSelect) {
    console.error('Sort select element not found!');
    return;
  }
  Shopify.queryParams = {};
  var getQueryParams = function getQueryParams() {
    var queryParams = {};
    if (location.search.length) {
      var params = new URLSearchParams(location.search);
      params.forEach(function (value, key) {
        if (queryParams[key]) {
          queryParams[key] = [].concat(queryParams[key], value);
        } else {
          queryParams[key] = value;
        }
      });
    }
    return queryParams;
  };
  Shopify.queryParams = getQueryParams();
  var updateParamsAndFilter = function updateParamsAndFilter() {
    var resetPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var queryParams = getQueryParams();
    var formData = new FormData(filterForm);
    Array.from(filterForm.elements).forEach(function (element) {
      if (element.name && queryParams[element.name]) {
        delete queryParams[element.name];
      }
    });
    formData.forEach(function (value, key) {
      if (value) {
        if (queryParams[key]) {
          queryParams[key] = [].concat(queryParams[key], value);
        } else {
          queryParams[key] = value;
        }
      }
    });
    if (resetPage) {
      queryParams.page = 1;
    }
    if (Shopify.queryParams.sort_by) {
      queryParams.sort_by = Shopify.queryParams.sort_by;
    }
    var searchParams = new URLSearchParams();
    Object.keys(queryParams).forEach(function (key) {
      if (Array.isArray(queryParams[key])) {
        queryParams[key].forEach(function (value) {
          return searchParams.append(key, value);
        });
      } else {
        searchParams.append(key, queryParams[key]);
      }
    });
    var urlWithParams = "".concat(window.location.pathname, "?").concat(searchParams.toString());
    window.history.pushState({}, '', urlWithParams);
    Shopify.queryParams = queryParams;
    fetchAndUpdateDOM(urlWithParams);
  };
  var bindPaginationLinks = function bindPaginationLinks() {
    document.querySelectorAll('#js-filters a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var url = new URL(this.href);
        var params = new URLSearchParams(url.search);
        var scrollTarget = document.getElementById('js-products-top');
        if (scrollTarget) {
          scrollTarget.scrollIntoView({
            behavior: 'smooth'
          });
        }
        var paramString = '';
        Object.keys(Shopify.queryParams).forEach(function (key) {
          if (key !== 'page') {
            var value = Shopify.queryParams[key];
            if (Array.isArray(value)) {
              paramString += value.map(function (v) {
                return "".concat(key, "=").concat(encodeURIComponent(v));
              }).join('&') + '&';
            } else {
              paramString += "".concat(key, "=").concat(encodeURIComponent(String(value)), "&");
            }
          }
        });
        paramString += "page=".concat(params.get('page'));
        var finalUrl = "".concat(url.pathname, "?").concat(paramString);
        window.history.pushState({}, '', finalUrl);
        fetchAndUpdateDOM(finalUrl);
      });
    });
  };
  bindPaginationLinks();
  filterForm.addEventListener('change', function (e) {
    e.preventDefault();
    updateParamsAndFilter(true);
  });
  sortSelect.addEventListener('change', function (e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    var queryParams = getQueryParams();
    queryParams.sort_by = value;
    Shopify.queryParams = queryParams;
    var paramString = '';
    Object.keys(queryParams).forEach(function (key) {
      var value = queryParams[key];
      if (Array.isArray(value)) {
        paramString += value.map(function (v) {
          return "".concat(key, "=").concat(encodeURIComponent(v));
        }).join('&') + '&';
      } else {
        paramString += "".concat(key, "=").concat(encodeURIComponent(String(value)), "&");
      }
    });
    var urlWithParams = "".concat(window.location.pathname, "?").concat(paramString);
    window.history.pushState({}, '', urlWithParams);
    fetchAndUpdateDOM(urlWithParams);
  });

  /**
   * Fetch & Update DOM
   */
  var fetchAndUpdateDOM = function fetchAndUpdateDOM(url) {
    axios.get(url).then(function (response) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(response.data, 'text/html');
      document.querySelector('#js-products-grid').innerHTML = doc.querySelector('#js-products-grid').innerHTML;
      document.querySelector('#js-results').innerHTML = doc.querySelector('#js-results').innerHTML;
      document.querySelector('#js-pagination').innerHTML = doc.querySelector('#js-pagination').innerHTML;
      document.querySelector('#js-filters').innerHTML = doc.querySelector('#js-filters').innerHTML;
      bindPaginationLinks();
      if (typeof callback === 'function') callback();
    })["catch"](function (error) {
      return console.error('Error loading content:', error);
    });
  };
});

/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/filters.js"));
/******/ }
]);